module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mobile@2x-d1f9ab6ea67e75411d987d475a95255e.webp";